import { Injectable } from '@angular/core';
import { Equipment, Tooling, Workcenter, Workforce, Worker } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class ProcessSheetOperationService {

  workersList: Worker[] = [];
  workcentersList: Workcenter[] = [];
  equipmentsList: Equipment[] = [];
  toolsList: Tooling[] = [];
  workforcesList: Workforce[] = [];

  constructor() { }
}
